const ConstantsRouters = {
    ROUTER_NAME_DASHBOARD_ADM: 'adm-home',
    ROUTER_NAME_MY_VEHICLE_REQUEST_USER: 'driver-vehicle-request-dashboard',
    ROUTER_NAME_MY_VEHICLE_REQUEST_MANAGER: 'manager-vehicle-request-dashboard',
    ROUTER_NAME_MANAGEMENT_VEHICLE_REQUEST: 'management-vehicle-request',
    ROUTER_NAME_DEFINE_DRIVER_VEHICLE_REQUEST: 'vehicle-request-define-driver',
    ROUTER_NAME_ADM_VEHICLE_REQUEST_REPORT: 'vehicle-request-report',

    ROUTER_NAME_ADM_VEHICLE_REQUEST_DETAIL: 'adm-vehicle-request-detail',
    ROUTER_NAME_USER_VEHICLE_REQUEST_DETAIL: 'driver-vehicle-request-detail',
    ROUTER_NAME_MANAGER_VEHICLE_REQUEST_DETAIL: 'manager-vehicle-request-detail',
    ROUTER_NAME_TCS_VEHICLE_REQUEST_DETAIL: 'tcs-vehicle-request-detail',
    ROUTER_NAME_ADM_SERVICE: 'adm-services',
    ROUTER_NAME_SERVICE: 'adm-services',

    ROUTER_NAME_USER_VEHICLE_REQUEST: "driver-vehicle-request",

    ROUTER_NAME_DRIVER_VEHICLE_REQUEST: "call-driver-vehicle-request-detail",
    ROUTER_NAME_DRIVER_VEHICLE_REQUEST_DASHBOARD: "calls-vehicle-request-dashboard"
};

export default ConstantsRouters